import PageBreadcrumb from "../components/common/PageBreadCrumb";
import PageMeta from "../components/common/PageMeta";
import ContentTable from "../components/tables/ContentTable";

export default function ContentPage() {
    return (
        <>
            <PageMeta
                title="CMS & Content | Shoplattice Admin Dashboard"
                description="Manage Content Pages, Banners, Menus"
            />
            <PageBreadcrumb pageTitle="CMS & Content" />
            <div className="space-y-6">
                <ContentTable />
            </div>
        </>
    );
}
